export default "__VITE_ASSET__D18s2IyD__"